<template>
    <div class="related-feed">
        <div class="details-title">{{ feed.display_name }}</div>
        <el-row :gutter="0" class="capitalize">
            <el-col :offset="1" :span="7">
                <div class="taker-feed-label">start date</div>
                <div class="taker-feed-value">{{ feed.start_date | moment("YYYY.MM.DD") }}</div>
            </el-col>
            <el-col :span="7">
                <div class="taker-feed-label">at</div>
                <span class="taker-feed-value">{{ startTime | moment("HH:mm") }}</span>
                <span style="font-size: 12px;">utc0</span>
            </el-col>
            <el-col :span="4">
                <div class="taker-feed-label">duration</div>
                <div class="taker-feed-value">{{ duration }}</div>
            </el-col>
            <el-col :span="5">
                <btn-manage-right
                    :feed-finished="feed.status === 'FINISHED'"
                    :feedConfirmed="feed.confirmed"
                    :broadcast-right="relatedBroadcastRight"
                    @create-broadcast-right="createBroadcastRight"
                    @delete-broadcast-right="deleteBroadcastRight"
                ></btn-manage-right>
            </el-col>
        </el-row>

        <div class="see-more-link" @click="showFeed">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import BtnManageRight from '../../partials/manage-broadcast-right.vue';
export default {

    components: {
        BtnManageRight,
    },
    props: {
        feed: {
            type: Object,
            required: true
        },
        broadcastRights: {
            type: Array,
            required: true
        },
        takerUid: {
            type: String,
            required: true
        },
    },

    data: function(){
        return {
            checked: true,
        };
    },
    computed: {
        startTime (){
            return this.feed.confirmed ? this.feed.confirmed_start_date : this.feed.start_date;
        },
        duration() {
            return moment(this.feed.end_date).diff(this.feed.start_date, 'minutes');
        },
        relatedBroadcastRight (){
            return this.broadcastRights.find(
                br => br.revoked === false && br.taker_uid === this.takerUid &&
                br.feed_uid === this.feed.uid
            ) || null;
        },
    },
    methods: {
        deleteBroadcastRight (){
            if(this.relatedBroadcastRight){
                this.$store.dispatch('patchItem', {
                    item: {
                        uid: this.relatedBroadcastRight.uid,
                        revoked: true,
                        revocation_date: moment.utc().format(),
                        url: this.relatedBroadcastRight.url
                    },
                    model: 'broadcastRight',
                }).then((res) => {
                    this.$message({
                        message: `Broadcast right revoked for feed ${this.feed.display_name} and taker ${this.$store.getters.takersByUid(res.taker_uid).name}`,
                        type: 'success',
                    });
                    this.$emit('fetch-broadcastrights');
                }).catch((e) => {
                    this.$message.error('Error on broadcast right revocation.');
                    console.error(e);
                });
            }
        },

        createBroadcastRight (){
            if(this.relatedBroadcastRight){
                this.$store.dispatch('patchItem', {
                    item: {
                        uid: this.relatedBroadcastRight.uid,
                        revoked: false,
                        revocation_date: null,
                        url: this.relatedBroadcastRight.url
                    },
                    model: 'broadcastRight',
                }).then((res) => {
                    this.$message({
                        message: `Broadcast right created for feed ${this.feed.display_name} and taker ${this.$store.getters.takersByUid(res.taker_uid).name}`,
                        type: 'success',
                    });
                    this.$emit('fetch-broadcastrights');
                }).catch((e) => {
                    this.$message.error('Error on broadcast right creation.');
                    console.error(e);
                });
            }
            else{
                this.$store.dispatch('createItem', {
                    item: {
                        feed_uid: this.feed.uid,
                        taker_uid: this.takerUid
                    },
                    model: 'broadcastRight',
                    url: this.$store.state.api.meta.listModels.broadcastRight.url,
                    scopes: {'X-Entity-Uid': this.feed.scopes.entity_uid },
                }).then((res) => {
                    this.$message({
                        message: `Broadcast right created for feed ${this.feed.display_name} and taker ${this.$store.getters.takersByUid(res.taker_uid).name}`,
                        type: 'success',
                    });
                    this.$emit('fetch-broadcastrights');
                }).catch((e) => {
                    this.$message.error('Error on broadcast right creation.');
                    console.error(e);
                });
            }
        },
        showFeed () {
            this.$router.push({
                name: 'feeds',
                params: { feedUid: this.feed.uid}
            });
        }
    }
};
</script>

<style lang="scss">
.related-feed {
    background-color: #222;
    padding: 15px;
    border-radius: 4px;
    font-family: roboto;
    &.related-feed {
        margin-top: 10px;
    }
    .confirmation-pending{
        img{
            margin-right: 5px;
        }

        font-size: 9px;
        color: #FFDC42;
        text-transform: uppercase;
    }
    .taker-feed-label{
        font-size: 9px;
    }
    .taker-feed-value{
        font-weight: bold;
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Takers/relatedFeed.vue